import styled, { css } from 'styled-components';

import { SliderSizeProps } from './Promotion/styled';
import { device } from '@/styles/helpers';

export const ScSliderContainer = styled.div<SliderSizeProps>`
  width: 100%;
  overflow: hidden;
  min-height: 84px;
  margin-bottom: -24px;

  .swiperArrow {
    margin-top: 0px;
    transform: translate(0, -50%);
    z-index: 5;
    position: absolute;
    left: 32px;
    right: auto;

    &:last-child {
      left: auto;
      right: 32px;
    }
  }
  ${({ isSliderDecreaseSize }) =>
    isSliderDecreaseSize &&
    css`
      @media (${device.mobile}) {
        .pagination {
          top: unset;
          bottom: -7px;
        }
      }
    `}
`;
